import React from 'react';
import {useDataProvider} from 'react-admin';

export const useUserTotalCount = () => {
    const dataProvider = useDataProvider();
    const [total, setTotal] = React.useState(null);

    React.useEffect(() => {
        let active = true;

        dataProvider
            .getList('user', {
                pagination: {page: 1, perPage: 1},
                sort: {field: 'email', order: 'ASC'},
                filter: {},
            })
            .then(result => {
                if (!active) {
                    return;
                }

                const value = Number(result && result.total);
                setTotal(Number.isFinite(value) ? value : null);
            })
            .catch(() => {
                if (active) {
                    setTotal(null);
                }
            });

        return () => {
            active = false;
        };
    }, [dataProvider]);

    return total;
};

export const UserCountBadge = ({total}) => {
    if (total === null || total === undefined) {
        return null;
    }

    return (
        <span
            style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                minWidth: 28,
                height: 22,
                padding: '0 7px',
                marginLeft: 12,
                borderRadius: 12,
                background: '#eeeeee',
                color: '#333333',
                fontSize: 12,
                fontWeight: 700,
                lineHeight: 1,
                boxSizing: 'border-box',
            }}
        >
            {total}
        </span>
    );
};


export const UserListTitle = () => {
    const total = useUserTotalCount();

    return (
        <span
            style={{
                display: 'inline-flex',
                alignItems: 'center',
            }}
        >
            <span>Utilisateurs</span>
            <UserCountBadge total={total} />
        </span>
    );
};
